module.exports = __webpack_public_path__ + "img/caret-up-square.4511a406.svg";